import { render } from "./nurse-news.vue?vue&type=template&id=02a82cb0&scoped=true"
import script from "./nurse-news.vue?vue&type=script&lang=js"
export * from "./nurse-news.vue?vue&type=script&lang=js"

import "./nurse-news.vue?vue&type=style&index=0&id=02a82cb0&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a82cb0"]])

export default __exports__